import React, { Component } from 'react';

import { IS_VALID } from 'utils';

import Create from './Create';
import View from './View';

export default class FormContainer extends Component {
	render() {
		let {
			actions,

			selectedData,
			formType,

			loadOptions,
			getRelation,
			uploadSpecificUserCSVFile,
		} = this.props;

		let createProps = {
			actions,
			loadOptions,
			getRelation,
			uploadSpecificUserCSVFile,
		};

		let viewProps = {
			selectedData,
			getRelation,
		};

		switch (formType.toUpperCase()) {
			case 'CREATE':
				return <Create {...createProps} />;
				break;
			case 'UPDATE':
				return <Create {...createProps} />;
				break;
			case 'VIEW':
				return <View {...viewProps} />;
				break;
			case 'DELETE':
				return (
					<p>
						Are you sure you want to delete&nbsp;
						{IS_VALID(selectedData) && IS_VALID(selectedData.get('name')) ? (
							<span style={{ color: 'red' }}>{selectedData.get('name')}</span>
						) : (
							'this data'
						)}
						?
					</p>
				);
				break;
			default:
				return '';
				break;
		}
	}

	componentWillUnmount() {
		let { actions } = this.props;

		actions.setValue({
			selectedData: null,
			formType: '',
			formId: '',
			formTitle: '',

			name: '',
			label: '',
			isEpicMillions: false,
			url: '',
			browser: {
				label: 'Internal',
				value: 'INTERNAL',
			},
			isUseGoogleChrome: false,
			icon: null,
			isNew: false,
			position: {
				label: 'Top',
				value: 'TOP',
			},
			sort: 0,
			cardType: [],
			excludedCardType: [],
			specificUser: [],
			blacklistedUser: [],
			deviceType: {
				label: 'All',
				value: 'ALL',
			},
			isUploadingCSVFile: false,
			isUploadingCSVFileBlacklistedUser: false,
		});
	}
}



// WEBPACK FOOTER //
// ./components/AppMenu/FormContainer/index.js